const ComponentDefaultProps = {
  conditions: {
    variants: [{
      id: 1,
      title: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.FIRST.TITLE',
      variantCostsLink: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.FIRST.LINK_URL',
      items: [{
        itemId: 1,
        itemTitle: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.FIRST.ITEM.FEE.TITLE',
        itemSummary: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.FIRST.ITEM.FEE.SUMMARY',
        itemValueType: 'CURRENCY',
        itemValue: 29000,
        itemIsDiscount: false,
        itemDiscountType: 'PERCENTAGE',
      }, {
        itemId: 2,
        itemTitle: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.FIRST.ITEM.INTEREST.TITLE',
        itemSummary: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.FIRST.ITEM.INTEREST.SUMMARY',
        itemValueType: 'PERCENTAGE',
        itemValue: 0,
        itemIsDiscount: false,
        itemDiscountType: 'PERCENTAGE',
      }],
    }, {
      id: 2,
      title: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.SECOND.TITLE',
      variantCostsLink: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.SECOND.LINK_URL',
      items: [{
        itemId: 3,
        itemTitle: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.SECOND.ITEM.FEE.TITLE',
        itemSummary: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.SECOND.ITEM.FEE.SUMMARY',
        itemValueType: 'CURRENCY',
        itemValue: 19000,
        itemIsDiscount: false,
        itemDiscountType: 'PERCENTAGE',
      }, {
        itemId: 4,
        itemTitle: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.SECOND.ITEM.INTEREST.TITLE',
        itemSummary: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.SECOND.ITEM.INTEREST.SUMMARY',
        itemValueType: 'PERCENTAGE',
        itemValue: 30,
        itemIsDiscount: true,
        itemDiscountType: 'PERCENTAGE',
      }],
    }, {
      id: 3,
      title: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.THIRD.TITLE',
      variantCostsLink: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.THIRD.LINK_URL',
      items: [{
        itemId: 5,
        itemTitle: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.THIRD.ITEM.FEE.TITLE',
        itemSummary: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.THIRD.ITEM.FEE.SUMMARY',
        itemValueType: 'CURRENCY',
        itemValue: 12000,
        itemIsDiscount: false,
        itemDiscountType: 'PERCENTAGE',
      }, {
        itemId: 6,
        itemTitle: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.THIRD.ITEM.INTEREST.TITLE',
        itemSummary: 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.THIRD.ITEM.INTEREST.SUMMARY',
        itemValueType: 'PERCENTAGE',
        itemValue: 0,
        itemIsDiscount: true,
        itemDiscountType: 'VALUE',
      }],
    }],
  },
};

export default ComponentDefaultProps;
